export const ArtifactSurfaces = {
  TOOLBAR: 'Artifact.TOOLBAR',
  CONTENT: 'Artifact.CONTENT',
  CHIP: 'Artifact.CHIP',
  // Toolbar action rendered in the external (public, no-auth) share viewer's
  // header, letting each artifact type own its share-context action (e.g. a
  // type-appropriate download/export) instead of the host hardcoding one.
  PUBLIC_VIEWER_TOOLBAR: 'Artifact.PUBLIC_VIEWER_TOOLBAR'
};

/**
 * One artifact referenced by a canvas publication, as resolved by getCanvas
 * (orch #1304) from the publication's stored VFS paths to id-bearing metadata.
 *
 * This is the generated CHIRP `BreezeArtifact` itself, re-exported from the SDK
 * (the dependency leaf) so both breeze-artifacts-ui (canvasData) and
 * breeze-canvas-host (the read layer) can share it without a circular import,
 * and so consumers do not re-derive a hand-rolled parallel shape that can drift
 * from the wire type. The FE only ever reads `.id` off it; the rest travels
 * along untouched.
 */

// Serialized canvas form values: each key maps to the list of values
// submitted under it (checkboxes and multi-select record lists append; a
// single field is a one-element array), mirroring iteration over FormData.
/** Payload emitted when a canvas view is submitted via an hs-action-button. */
/** Primary action of an artifact toolbar (the leading split-button segment). */
/** A secondary action rendered in the toolbar's overflow menu. */
/** How the artifact host applies Ask Breeze text selection for this type. */
// plugin owns scoping (editable composer, partial surface)
/** Whether a newly-created artifact of this type auto-opens the canvas. */
// auto-open except in these host apps